import * as React from 'react';

export const withState =
  (valueName, fnName, defVal = null) =>
  (WrappedComponent) => {
    class WithState extends React.Component {
      state = {
        val: defVal,
      };

      applyState = (val) => {
        this.setState({ val });
      };

      render() {
        const props = {
          ...this.props,
          [fnName]: this.applyState,
          [valueName]: this.state.val,
        };
        return <WrappedComponent {...props} />;
      }
    }

    WithState.displayName = WrappedComponent.displayName;
    return WithState;
  };

export default withState;
